import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, doc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import PacksList from './PacksList';
import PackEditor from './PackEditor';
import { FiArrowLeft } from 'react-icons/fi';

export default function PacksManager() {
  const [packs, setPacks] = useState([]);
  const [selectedPack, setSelectedPack] = useState(null);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('list'); // 'list' | 'edit' | 'new'

  useEffect(() => {
    loadPacks();
  }, []);

  async function loadPacks() {
    setLoading(true);
    try {
      const snapshot = await getDocs(collection(db, 'packs'));
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setPacks(data.sort((a, b) => (a.title || '').localeCompare(b.title || '')));
    } catch (error) {
      console.error('Erro ao carregar packs:', error);
      setPacks([]);
    } finally {
      setLoading(false);
    }
  }

  async function savePack(packData) {
    try {
      const packId = packData.id || packData.productIdAndroid;
      
      if (!packId) {
        console.error('Product ID Android não foi gerado');
        return false;
      }
      
      // Remover o campo 'id' antes de salvar (o ID é o documento, não um campo)
      const { id, ...dataToSave } = packData;
      
      await setDoc(doc(db, 'packs', packId), {
        ...dataToSave,
        updatedAt: new Date().toISOString()
      }, { merge: true });
      
      await loadPacks();
      setView('list');
      setSelectedPack(null);
      return true;
    } catch (error) {
      console.error('Erro ao salvar pack:', error);
      return false;
    }
  }

  async function deletePack(packId) {
    if (!window.confirm('Tem certeza que deseja excluir este pack?')) return;
    try {
      await deleteDoc(doc(db, 'packs', packId));
      await loadPacks();
    } catch (error) {
      console.error('Erro ao deletar pack:', error);
    }
  }

  function handleEdit(pack) {
    setSelectedPack(pack);
    setView('edit');
  }

  function handleNew() {
    setSelectedPack({
      title: '',
      productId: '',
      image: '',
      price: 'R$ 4,99',
      description: '',
      locked: true,
      showInDiary: true,
      questions: []
    });
    setView('new');
  }

  function handleBack() {
    setView('list');
    setSelectedPack(null);
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <Link to="/" style={styles.backLink}>
            <FiArrowLeft size={20} /> Voltar ao Dashboard
          </Link>
          <h1 style={styles.title}>
            {view === 'list' ? 'Gerenciar Packs' : view === 'edit' ? 'Editar Pack' : 'Novo Pack'}
          </h1>
        </div>
      </div>

      {view === 'list' ? (
        <PacksList
          packs={packs}
          loading={loading}
          onEdit={handleEdit}
          onDelete={deletePack}
          onNew={handleNew}
        />
      ) : (
        <PackEditor
          pack={selectedPack}
          onSave={savePack}
          onCancel={handleBack}
        />
      )}
    </div>
  );
}

const styles = {
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: 24,
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  header: {
    marginBottom: 24,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  backLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    color: '#1f6feb',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 600,
  },
  title: {
    fontSize: 28,
    fontWeight: 800,
    margin: 0,
    color: '#111',
  },
};
